<template>
  <div>
    <PageHeader title="Tarieven">
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas sit amet iaculis est.
      In commodo magna quis orci tristique, eu pretium ex auctor. Aenean lectus eros, viverra
      vitae felis a, lacinia porttitor lectus.
    </PageHeader>

    <section class="uk-container uk-margin-large-top">
      <h2 class="uk-margin-large-bottom">De prijs van een voice over</h2>
      <div class="uk-margin-xlarge-left uk-margin-xlarge-right">
        <div class="uk-grid uk-margin-large" uk-grid>
          <div class="uk-width-1-2@s">
            <ExplainBlock
              title="De lengte van een tekst"
              :icon="require('@/assets/images/icons/icon-percentage.svg')"
            >
              De lengte van tekst geeft een goede indicatie hoeveel tijd ik er mee
              kwijt ben. Ik bereken de prijzen dan ook per woord. Vanzelfsprekend
              wordt de prijs per woord goedkoper als je meer afneemt. Zie onderstaande tabel
              voor de prijzen.
            </ExplainBlock>
          </div>

          <div class="uk-width-1-2@s">
            <ExplainBlock
              title="Exclusiviteit"
              :icon="require('@/assets/images/icons/icon-star-badge.svg')"
            >
              Sommige bedrijven of merken vinden het belangrijk om herkenbaar en uniek te zijn
              in hun audio(visuele) uitingen. In dat licht verlangen sommige opdrachtgevers een
              exclusief gebruik van mijn stem. Dat is - in overleg - mogelijk.
            </ExplainBlock>
          </div>

          <div class="uk-width-1-2@s">
            <ExplainBlock
              title="Pakket-deal"
              :icon="require('@/assets/images/icons/icon-percentage.svg')"
            >
              Wanneer je meerdere video’s of Voice-Response systemen tegelijk door me wilt
              laten inspreken, kan ik meestal wel wat met de prijs doen.
            </ExplainBlock>
          </div>

          <div class="uk-width-1-2@s">
            <ExplainBlock
              title="Voice Response"
              :icon="require('@/assets/images/icons/icon-phone.svg')"
            >
              Je wilt dat je klanten professioneel en warm welkom heten als zij de moeite nemen
              om jouw bedrijf te bellen. Door het telefoontje direct te beantwoorden met een vooraf
              opgenomen welkom ben je daar in elk geval zeker van.
            </ExplainBlock>
          </div>
        </div>
      </div>
    </section>

    <section class="uk-container uk-margin-xlarge-bottom">
      <ul class="uk-child-width-expand uk-width-2-3@l uk-margin-auto"
          uk-tab="media: @m; animation: uk-animation-slide-down"
      >
        <li class="uk-active">
          <a href="" class=""><span class="uk-visible@s">(Online) </span>Video</a>
        </li>
        <li>
          <a href="" class="">Commercial</a>
        </li>
        <li>
          <a href="" class="">Telefonie</a>
        </li>
      </ul>

      <ul class="uk-switcher uk-width-2-3@l uk-margin-auto">
        <li class="uk-overflow-auto">
          <p>
            Ik werk met 'gestapelde' prijzen. Dat houdt in dat hoe meer je afneemt, hoe goedkoper
            het per woord wordt. Keerzijde hiervan is dat je niet in één opslag ziet wat je tekst
            kost. Gelukkig heb ik hier een tooltje voor op de website staan:
            <router-link to="/aanvragen">bereken jouw prijs</router-link>
          </p>

          <ul class="" uk-accordion="multiple: true">
            <li>
              <a href="" class="uk-accordion-title uk-text-small uk-text-primary">
                Zelf de prijs berekenen
              </a>
              <div class="uk-accordion-content">
                <p class="uk-text-small">
                  Je kunt ook zelf gaan rekenen. Hiervoor kun je onderstaande tabel gebruiken.<br>
                  &bull; Bereken het aantal woorden van je tekst<br>
                  &bull; Zoek de rij op waarin dat aantal valt.<br>
                  &bull; Tel het aantal woorden welke in deze regel vallen<br>
                  &bull; Vermenigvuldig dit aantal met de prijs per woord<br>
                  &bull; Tel daar het maximale tarief uit de vorige regel bij op<br>
                  &bull; Dit is je prijs.
                </p>
              </div>
            </li>
            <li>
              <a href="" class="uk-accordion-title uk-text-small uk-text-primary">
                Een voorbeeld
              </a>
              <div class="uk-accordion-content">
                <p class="uk-text-small">
                  &bull; Je hebt een tekst van 425 woorden.<br>
                  &bull; Je valt in het tarief op de derde rij (€ 0,35 p/w).<br>
                  &bull; Tot en met 250 woorden vallen in het voorgaande tarief.
                  Dus 425 - 250 = 175 woorden.<br>
                  &bull; 175 x 0,35 = € 61,25.<br>
                  &bull; Je telt daar het maximale bedrag uit de vorige rij bij op (€ 199,00). <br>
                  &bull; In totaal kom je uit op een bedrag van € 199 + € 61,25 = € 260,25.
                </p>
              </div>
            </li>
            <li>
              <a href="" class="uk-accordion-title uk-text-small uk-text-primary">
                Licentie (of waar mag je de video allemaal gebruiken)
              </a>
              <div class="uk-accordion-content">
                <p class="uk-text-small">
                  De meeste toepassingen vallen onder (online) video's. Video's mogen gebruikt
                  worden op eigen kanalen (website, social media, etc.). Wil je een video met
                  mijn stem inzetten in een (betaalde) media campagne (bijvoorbeeld televisie,
                  radio of Facebook ads) dan kun je beter kijken naar de prijzen van 'commercials'.
                </p>
              </div>
            </li>
          </ul>
          <table class="uk-table pricing-table">
            <thead>
              <tr>
                <th class="uk-width-medium">Aantal woorden</th>
                <th class="uk-width-medium">Prijs per woord</th>
                <th class="uk-width-small">Maximaal</th>
                <th class="uk-width-small"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>tot <em>100</em> woorden</td>
                <td>-</td>
                <td><em>€ 99</em></td>
                <td>
                  <a class="uk-button uk-button-small uk-button-secondary">Bestellen</a>
                </td>
              </tr>
              <tr>
                <td><em>101-250</em> woorden</td>
                <td><em>€ 0,40</em></td>
                <td><em>€ 159</em></td>
                <td>
                  <a class="uk-button uk-button-small uk-button-secondary">Bestellen</a>
                </td>
              </tr>
              <tr>
                <td><em>251-750</em> woorden</td>
                <td><em>€ 0,35</em></td>
                <td><em>€ 334</em></td>
                <td>
                  <a class="uk-button uk-button-small uk-button-secondary">Bestellen</a>
                </td>
              </tr>
              <tr>
                <td><em>751-1250</em> woorden</td>
                <td><em>€ 0,30</em></td>
                <td><em>€ 484</em></td>
                <td>
                  <a class="uk-button uk-button-small uk-button-secondary">Bestellen</a>
                </td>
              </tr>
              <tr>
                <td><em>1251-2500</em> woorden</td>
                <td><em>€ 0,20</em></td>
                <td><em>€ 734</em></td>
                <td>
                  <a class="uk-button uk-button-small uk-button-secondary">Bestellen</a>
                </td>
              </tr>
              <tr>
                <td><em>2501-5000</em> woorden</td>
                <td><em>€ 0,15</em></td>
                <td><em>€ 1.109</em></td>
                <td>
                  <a class="uk-button uk-button-small uk-button-secondary">Bestellen</a>
                </td>
              </tr>
              <tr>
                <td>v.a. <em>5000</em> woorden</td>
                <td><em>€ 0,13</em></td>
                <td>-</td>
                <td>
                  <a class="uk-button uk-button-small uk-button-secondary">Bestellen</a>
                </td>
              </tr>
            </tbody>
          </table>
        </li>
        <li>
          <p>
            Commercials zijn er in verschillende soorten en maten, maar zijn over het algemeen
            een stuk duurder dan online videos. De prijzen bestaan uit twee delen. De opname zelf
            en een buy-out fee, wat je het recht geeft de commercial in te zetten.
          </p>
          <ul class="" uk-accordion="multiple: true">
            <li>
              <a href="" class="uk-accordion-title uk-text-small uk-text-primary">
                Prijs berekenen
              </a>
              <div class="uk-accordion-content">
                <p class="uk-text-small">
                  Het buy-out bedrag is afhankelijk van het potentieel bereik. Dit verschilt per
                  medium en uitzendschaal, maar heeft niets met de lengte van de commercial te
                  maken. De opname-fee is wel afhankelijk van de uiteindelijke commercialtijd.
                </p>
                <p class="uk-text-small">
                  Lang verhaal kort: je betaalt een buy-out én een opnamefee. Deze staan beide in
                  de tabel hieronder.
                </p>
              </div>
            </li>
            <li>
              <a href="" class="uk-accordion-title uk-text-small uk-text-primary">
                Licentie (of hoe mag ik de commercial gebruiken)
              </a>
              <div class="uk-accordion-content">
                <p class="uk-text-small">
                  Een commercial met mijn stem mag maar voor een bepaalde tijd ingezet worden.
                  Meestal is dat een jaar. Je betaalt hiervoor een 'buy-out fee'. Wil je de
                  commercial na deze afgesproken periode nog langer (of opnieuw) inzetten dan
                  betaal je - na overleg - 150% van de initiële buy-out.
                </p>
              </div>
            </li>
          </ul>

          <table class="uk-table pricing-table">
            <caption>Buy-out fees</caption>
            <thead>
              <tr>
                <th class="uk-width-medium">Buy-out</th>
                <th class="uk-width-small">Lokaal</th>
                <th class="uk-width-small">Regionaal</th>
                <th class="uk-width-small">Nationaal</th>
                <th class="uk-width-small"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><em>Televisie</em></td>
                <td><em>€ 100</em></td>
                <td><em>€ 400</em></td>
                <td><em>€ 700</em></td>
                <td>
                  <a class="uk-button uk-button-small uk-button-secondary">Bestellen</a>
                </td>
              </tr>
              <tr>
                <td><em>Radio</em></td>
                <td><em>-</em></td>
                <td><em>€ 300</em></td>
                <td><em>€ 600</em></td>
                <td>
                  <a class="uk-button uk-button-small uk-button-secondary">Bestellen</a>
                </td>
              </tr>
              <tr>
                <td><em>Online</em></td>
                <td>-</td>
                <td>-</td>
                <td><em>€ 300</em></td>
                <td>
                  <a class="uk-button uk-button-small uk-button-secondary">Bestellen</a>
                </td>
              </tr>
            </tbody>
          </table>

          <table class="uk-table pricing-table">
            <caption>Opnamefees</caption>
            <thead>
            <tr>
              <th class="uk-width-medium">Air-time / Lengte</th>
              <th class="uk-width-small">Prijs</th>
              <th class="uk-width-small"></th>
            </tr>
            </thead>
            <tbody>
              <tr>
                <td>t/m <em>30</em> seconden</td>
                <td><em>€ 50</em></td>
                <td>
                  <a class="uk-button uk-button-small uk-button-secondary">Bestellen</a>
                </td>
              </tr>
              <tr>
                <td>t/m <em>45</em> seconden</td>
                <td><em>€ 75</em></td>
                <td>
                  <a class="uk-button uk-button-small uk-button-secondary">Bestellen</a>
                </td>
              </tr>
              <tr>
                <td>t/m <em>60</em> seconden<br> (1 minuut)</td>
                <td><em>€ 100</em></td>
                <td>
                  <a class="uk-button uk-button-small uk-button-secondary">Bestellen</a>
                </td>
              </tr>
              <tr>
                <td>t/m <em>75</em> seconden</td>
                <td><em>€ 120</em></td>
                <td>
                  <a class="uk-button uk-button-small uk-button-secondary">Bestellen</a>
                </td>
              </tr>
              <tr>
                <td>t/m <em>90</em> seconden</td>
                <td><em>€ 140</em></td>
                <td>
                  <a class="uk-button uk-button-small uk-button-secondary">Bestellen</a>
                </td>
              </tr>
              <tr>
                <td>t/m <em>105</em> seconden</td>
                <td><em>€ 160</em></td>
                <td>
                  <a class="uk-button uk-button-small uk-button-secondary">Bestellen</a>
                </td>
              </tr>
              <tr>
                <td>t/m <em>120</em> seconden<br> (2 minuten)</td>
                <td><em>€ 180</em></td>
                <td>
                  <a class="uk-button uk-button-small uk-button-secondary">Bestellen</a>
                </td>
              </tr>
              <tr>
                <td>vanaf <em>2</em> minuten</td>
                <td>op aanvraag</td>
                <td>
                  <a class="uk-button uk-button-small uk-button-secondary">Bestellen</a>
                </td>
              </tr>
            </tbody>
          </table>
        </li>

        <!--    CONTENT TELEFONIE    -->
        <li>
          <p>
            Omdat opnames voor telefoniesystemen heel kort kunnen zijn zijn hier wat andere prijzen
            voor van toepassing. Veel opnamen zijn al eens ingesproken (bijvoorbeeld: &ldquo;Toets
            1 voor Nederlands. Press 2 for English&rdquo;).
          </p>

          <table class="uk-table pricing-table">
            <thead>
            <tr>
              <th class="uk-width-medium">Aantal woorden</th>
              <th class="uk-width-medium">Prijs</th>
              <th class="uk-width-small"></th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>t/m <em>20</em> woorden</td>
              <td><em>€ 29</em></td>
              <td>
                <a class="uk-button uk-button-small uk-button-secondary">Bestellen</a>
              </td>
            </tr>
            <tr>
              <td>t/m <em>50</em> woorden</td>
              <td><em>€ 49</em></td>
              <td>
                <a class="uk-button uk-button-small uk-button-secondary">Bestellen</a>
              </td>
            </tr>
            <tr>
              <td>t/m <em>80</em> woorden</td>
              <td><em>€ 79</em></td>
              <td>
                <a class="uk-button uk-button-small uk-button-secondary">Bestellen</a>
              </td>
            </tr>
            <tr>
              <td>t/m <em>120</em> woorden</td>
              <td><em>€ 99</em></td>
              <td>
                <a class="uk-button uk-button-small uk-button-secondary">Bestellen</a>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                vanaf <em>121</em> woorden gelden de prijzen van
                 <em><a href="javascript:void(0);" uk-switcher-item="0">online video's</a></em>
              </td>
            </tr>
          </tbody>
        </table>
        </li>
      </ul>
    </section>

    <section class="uk-container">
      <PriceCalculatorSmall />
    </section>
  </div>
</template>
<script>
import PageHeader from '@/components/PageHeader.vue';
import ExplainBlock from '@/components/ExplainBlock.vue';
import PriceCalculatorSmall from '@/components/PriceCalculatorSmall.vue';

export default {
  components: { PriceCalculatorSmall, PageHeader, ExplainBlock },
};
</script>
